import type { PayShiftEntry } from '../teacherApi';

import ShiftRow from './ShiftRow';

export default function ShiftTable({
  shifts,
  salaried = false,
}: {
  shifts: PayShiftEntry[];
  salaried?: boolean;
}) {
  return (
    <table className="nb-tbl">
      <thead>
        <tr>
          <th>Date</th>
          <th>Workshop</th>
          <th>Paid as</th>
          <th>Status</th>
          <th style={{ textAlign: 'right' }}>Amount</th>
        </tr>
      </thead>
      <tbody>
        {shifts.map((s) => (
          <ShiftRow key={`${s.workshopId}-${s.position}`} shift={s} salaried={salaried} />
        ))}
      </tbody>
    </table>
  );
}
